import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { NotificationService } from '../../core/services/notification.service';
import { NewRequestService } from '../models/request/new-request/new-request-service';
import { MultipleRequestServices } from '../models/request/multiple-request-services';
import { Observable } from 'rxjs';
import { ActionResult } from '../models/core/ActionResult';
import { ActionDataResult } from '../models/core/ActionDataResult';

@Injectable()
export class RequestServicesService extends DataService<NewRequestService, NewRequestService> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = 'request-services';
  	}	

	createMultiple(model: MultipleRequestServices): Observable<ActionResult> {
		return this.postQuery(`${this.baseUrl()}/multiple`, model);
	}

	getTotalAmount(requestId: number): Observable<number> {
		return this.getQuery(`${this.baseUrl()}/get-total-amount?requestId=${requestId}`);
	}
}

